/* eslint-disable react/forbid-prop-types */
import React, { useContext } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import { Context } from '~context/MainProvider';
import MatchCard from '../../molecules/template-block-cards/match-card';
import styles from './template-block-cards.module.scss';

const TemplateBlockCards = ({ pageContext, isStorybook = false }) => {
  const { relation } = pageContext?.page;
  const { translations } = useContext(Context) || {};

  // Get first tournament scheduled events
  const schedule = relation?.schedule;
  const scheduleArray = schedule && Object.keys(schedule).map((key) => schedule[key]);
  const tournaments = scheduleArray && scheduleArray[0]?.tournaments;
  const tournamentsArray = tournaments && Object.keys(tournaments).map((key) => tournaments[key]);

  // Prepare data
  const featuredEvents = relation?.featured_events.slice(0, 3);
  const scheduledEvents = tournamentsArray && tournamentsArray[0].events.slice(0, 3);
  const matchCards = featuredEvents.length ? featuredEvents : scheduledEvents;

  return (
    <div className={styles.templateBlockCards}>
      <h2 className={styles.cardTitle}>
        {translate(translations, 'match_cards_title', 'Most Popular Upcoming Matches')}
      </h2>
      <p className={styles.cardContent}>
        {translate(
          translations,
          'match_cards_content',
          'Make us your ultimate resource for all that is live football - match previews, when, where and how to watch the latest big matches and even a guide.'
        )}
      </p>
      <div className={styles.cards}>
        {matchCards.map((item) => (
          <div key={item.id} className={styles.card}>
            <MatchCard item={item} page={pageContext.page} isStorybook={isStorybook} />
          </div>
        ))}
      </div>
    </div>
  );
};

TemplateBlockCards.propTypes = {
  pageContext: PropTypes.shape({
    page: PropTypes.shape({
      relation: PropTypes.shape({
        featured_events: PropTypes.arrayOf(PropTypes.object),
      }),
    }),
  }),
  isStorybook: PropTypes.bool,
};

export default TemplateBlockCards;
